export const SLOTS_API = "public/get-booking-slots-by-doctor-id-rev1";
export const PATIENT_FOLLOWUP_SLOTS =
  "patient/patient-follow-up-slots-by-doctor-id";
export const CLINIC_GET_APPT_SLOTS =
  "/clinic/get-appointments-slots-by-doctor-id";
export const PUBLIC_GET_APPT_SLOTS =
  "public/get-appointments-slots-by-doctor-id";
export const PUBLIC_GET_DOCTOR_SLUG = "/public/get-doctor-details-by-slug-rev1";
export const NEXT_SLOTS = "/api/v1/next-schedule";
